import axios, { AxiosResponse } from "axios";
import { RespuestaPostGrado } from "../interfaces/PostGrado/ResponsePost";
import { Programa } from "../interfaces/PostGrado/ResponsePost";
import { ResponceApi } from "../interfaces/Responses";
import { DoctoradosVigenciaDTO } from "../interfaces/PostGrado/DoctoradoVigenteDTO";
const SERVICE : string = process.env.REACT_APP_POSTGRADO || ''; 
const APIPROGRAMA : string = 'Programa/';
const Back : string = process.env.REACT_APP_BACK || ''; 
const APICATALOGO : string = '/api/Catalogo/';

export default class PostGradoServices{

    async GetProgramaPostgrados(token:any): Promise<any> {
        console.log(SERVICE+APIPROGRAMA+'consultaProgramasAcademicosVigentes');
        const response1:AxiosResponse<any> = await axios.get(SERVICE+APIPROGRAMA+'consultaProgramasAcademicosVigentes',{
            headers: {
              Authorization: `Bearer ${token}`
            }
        });
        //console.log(response1.data);        
        return response1.data;
    }

    async ConsultaProgramasAcademicosVigentes(token:any): Promise<ResponceApi<Programa>> {
        const response1:AxiosResponse<ResponceApi<Programa>> = await axios.get(Back+APICATALOGO+'consultaProgramasAcademicosVigentes',{
            headers: {
              Authorization: `Bearer ${token}`
            }
        });
        //console.log(response1.data);        
        return response1.data;
    }

    async GetDoctoradosVigencia(token:any): Promise<ResponceApi<DoctoradosVigenciaDTO>> {
        const response1:AxiosResponse<ResponceApi<DoctoradosVigenciaDTO>> = await axios.get(Back+APICATALOGO+'GetDoctoradosVigencia',{
            headers: {
              Authorization: `Bearer ${token}`
            }
        });
        //console.log(response1.data);        
        return response1.data;
    }
}